import { UIPanel, UIRow } from '@/components/assets/js/libs/ui.js';

function MenubarRemote( editor ) {

	const strings = editor.strings;

	const container = new UIPanel();
	container.setClass( 'menu' );

	const title = new UIPanel();
	title.setClass( 'title' );
	title.setTextContent( strings.getKey( 'menubar/Remote' ) );
	container.add( title );

	const options = new UIPanel();
	options.setClass( 'options' );
	container.add( options );

	
	
	function remoteRemote_support(){

		window.open( 'https://939.co.kr/stni001/', '_blank' );
	}


	window.remoteRemote_supportonClick = remoteRemote_support ;

	let option = new UIRow();
	option.setClass( 'option' );
	option.setTextContent( strings.getKey( 'menubar/Remote/Remote_support' ) );
	option.onClick( remoteRemote_support );
	options.add( option );

	return container;

}

export { MenubarRemote };
